import React, { useState } from "react";
import { Link } from "react-router-dom";
import './About.css'
import './About-responsive.css';
import { Slide, Fade, JackInTheBox, Zoom } from 'react-awesome-reveal';
import Tilt from 'react-parallax-tilt';
import { Ripple } from "primereact/ripple";
import { Dialog } from "primereact/dialog";
import ReactPlayer from 'react-player';

import { WhyWeBestReasons, whyWeBestReasons } from "./AboutData";
import { goToTop } from "../../../WebApp/Components/goToTop";
import { playStoreLink, appStoreLink } from "../../Utils/Info";

const About: React.FC = () => {
    const reasons = whyWeBestReasons.slice(0, 6);
    const listStyleImg = '/assets/images/website/about-page/check.svg';
    const videoUrl = '/assets/images/website/about-page/project_management_video.mp4';
    const [showVideoPlayerModal, setShowVideoPlayerModal] = useState<boolean>(false);

    const handlePlayVideo = () => {
        setShowVideoPlayerModal(true);
    }

    return (
        <React.Fragment>
            {/* About initial section */}
            <section className="page_initial_section about_init_section overflow-hidden">
                <div className="container-md">
                    <div className="row about_init_row">
                        <div className="col-12 col-lg-5 col-xl-5 my-auto">
                            <div className="about_init_content pe-lg-3">
                                <Fade triggerOnce>
                                    <h1 className="home_hero_title text_bold text-center text-lg-start">
                                        We construct your Dream home, you Track progress on app
                                    </h1>
                                </Fade>

                                <Slide direction="up" delay={100} triggerOnce>
                                    <p className="home_hero_desc text-center text-lg-start">
                                        We build your dream home while you easily track progress every step of the way through our app.
                                    </p>
                                </Slide>

                                <Slide direction="up" delay={100} triggerOnce>
                                    <div className="home_hero_app_section justify-content-center justify-content-lg-start">
                                        <Link target="_blank" to={appStoreLink} className="mb_app_link p-ripple">
                                            <img src="/assets/images/website/home-page/app_store.svg" alt="App Store" loading="lazy" />
                                            <Ripple />
                                        </Link>
                                        <Link target="_blank" to={playStoreLink} className="mb_app_link p-ripple">
                                            <img src="/assets/images/website/home-page/play_store.svg" alt="Play Store" loading="lazy" />
                                            <Ripple />
                                        </Link>
                                    </div>
                                </Slide>
                            </div>
                        </div>
                        <div className="col-12 col-lg-7 col-xl-7">
                            <Tilt
                                tiltMaxAngleX={10}
                                tiltMaxAngleY={10}
                                trackOnWindow={true}
                                className="tile_effect">
                                <div className="about_init_image_area">
                                    <Zoom direction="down" triggerOnce>
                                        <img src="/assets/images/website/about-page/about_watermark_bg.svg" loading="lazy" className="about_watermark_img" alt="Traqdo" />
                                    </Zoom>
                                    <Fade delay={100} big triggerOnce>
                                        <img src="/assets/images/website/about-page/mobile_app.svg" loading="lazy" className="mobile_app_img" alt="Traqdo" />
                                    </Fade>
                                </div>
                            </Tilt>
                        </div>
                    </div>
                </div>
            </section>

            {/* Little more about section */}
            <section className="section__padding why_choose_section">
                <div className="container-md">
                    <div className="why_choose_content">
                        <Fade delay={100} triggerOnce>
                            <h2 className="section_main_head has_img text-center">
                                Little More About Us
                            </h2>
                        </Fade>

                        <div className="row why_choose_content_row">
                            <div className="col-12 col-lg-4">
                                <Fade delay={0} triggerOnce>
                                    <Tilt tiltMaxAngleX={8} tiltMaxAngleY={8} className="tile_effect">
                                        <article className="why_choose_container first">
                                            <Fade delay={300} triggerOnce>
                                                <img src="assets/images/website/about-page/little_more_about_1.svg" loading="lazy" alt="Keep Everything in One Place" />
                                            </Fade>

                                            <div className="why_choose_container_sub">
                                                <Slide direction="up" delay={0} triggerOnce>
                                                    <h4>Take the stress out of<br />the project planning</h4>
                                                </Slide>

                                                <Slide direction="up" delay={50} triggerOnce>
                                                    <p>Traqdo let's you keep all your important tasks in one place, so you can avoid confusion and keep focusing on your important taks.</p>
                                                </Slide>
                                            </div>
                                        </article>
                                    </Tilt>
                                </Fade>
                            </div>
                            <div className="col-12 col-lg-4">
                                <Fade delay={50} triggerOnce>
                                    <Tilt tiltMaxAngleX={8} tiltMaxAngleY={8} className="tile_effect">
                                        <article className="why_choose_container second">
                                            <Fade delay={300} triggerOnce>
                                                <img src="assets/images/website/about-page/little_more_about_2.svg" loading="lazy" alt="Inexpensive & Fairly priced" />
                                            </Fade>

                                            <div className="why_choose_container_sub">
                                                <Slide direction="up" delay={0} triggerOnce>
                                                    <h4>Turn the process clearly <br />to management team</h4>
                                                </Slide>

                                                <Slide direction="up" delay={50} triggerOnce>
                                                    <p>We priced Traqdo fairly for both, whether you're a solo user or a team you can be sure that you'll find a package that suits your needs.</p>
                                                </Slide>
                                            </div>
                                        </article>
                                    </Tilt>
                                </Fade>
                            </div>
                            <div className="col-12 col-lg-4">
                                <Fade delay={100} triggerOnce>
                                    <Tilt tiltMaxAngleX={8} tiltMaxAngleY={8} className="tile_effect">
                                        <article className="why_choose_container third">
                                            <Fade delay={300} triggerOnce>
                                                <img src="assets/images/website/about-page/little_more_about_3.svg" loading="lazy" alt="Good for Individual & Entreprises" />
                                            </Fade>

                                            <div className="why_choose_container_sub">
                                                <Slide direction="up" delay={0} triggerOnce>
                                                    <h4>Keep the team in <br />tune via app</h4>
                                                </Slide>

                                                <Slide direction="up" delay={50} triggerOnce>
                                                    <p>Traqdo was designed to be used by both individuals and large enterprises. Our app is the best in the market.</p>
                                                </Slide>
                                            </div>
                                        </article>
                                    </Tilt>
                                </Fade>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why we best section */}
            <section className="why_we_best_section">
                <article className="why_we_best_container section__padding">
                    <div className="container-md">
                        <Fade delay={100} triggerOnce>
                            <h2 className="section_main_head text-center text-white mb-0">
                                <img src="/assets/images/traqdo_logo_icon_light.svg" alt="Traqo" loading="lazy" className="heading_icon" />
                                <br />
                                Why We Are Best
                            </h2>
                        </Fade>
                        <div className="why_we_best_content">
                            {whyWeBestReasons && whyWeBestReasons?.length > 0 && (
                                <div className="row why_we_best_row">
                                    {reasons?.map((reason, index) => (
                                        <div key={reason.id} className="col-12 col-lg-4 col-sm-6 h-100">
                                            <Tilt tiltMaxAngleX={6} tiltMaxAngleY={6} className="tile_effect">
                                                <Slide direction="up" delay={index * 25} triggerOnce>
                                                    <article className="best_reason_container">
                                                        <img src={reason.icon} alt={reason.title} loading="lazy" />
                                                        <h4>{reason.title}</h4>
                                                        <p>{reason.description}</p>
                                                    </article>
                                                </Slide>
                                            </Tilt>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <Slide direction="up" triggerOnce>
                            <div className="get_start_btn_area">
                                <Link to={'/auth/login'} className="tdo_button btn_fill p-ripple"
                                    onClick={goToTop}>
                                    Get Started Now
                                    <Ripple />
                                </Link>
                            </div>
                        </Slide>
                    </div>
                </article>
            </section>

            {/* Why trust traqdo section */}
            <section className="section__padding why_trust_section">
                <div className="container-md">
                    <Fade delay={100} triggerOnce>
                        <h2 className="section_main_head text-center">
                            Why people trust on traqdo?
                        </h2>
                    </Fade>

                    <div className="why_trust_content">
                        <Zoom triggerOnce>
                            <div className="why_trust_header">
                                <img src="/assets/images/website/about-page/scale.svg" loading="lazy" className="point_image" alt="" />
                                <div className="line_image"></div>
                                <img src="/assets/images/website/about-page/statics.png" loading="lazy" className="point_image" alt="" />
                                <div className="line_image"></div>
                                <img src="/assets/images/website/about-page/shield.svg" loading="lazy" className="point_image" alt="" />
                            </div>
                        </Zoom>
                        <div className="row why_trust_row">
                            <div className="col-12 col-xl-4 col-lg-4 col-sm-8 mx-auto">
                                <Slide direction="up" triggerOnce>
                                    <article className="why_trust_container">
                                        <div className="why_trust_img_area">
                                            <img src="/assets/images/website/about-page/3d_render.jpg" loading="lazy" alt="3D Render" />
                                        </div>
                                        <div className="why_trust_desc_area">
                                            <h4>3D Render</h4>
                                            <ul>
                                                <li><img src={listStyleImg} loading="lazy" alt="" />Planning Quality</li>
                                                <li><img src={listStyleImg} loading="lazy" alt="" />100% safe money transaction</li>
                                            </ul>
                                        </div>
                                    </article>
                                </Slide>
                            </div>

                            <div className="col-12 col-xl-4 col-lg-4 col-sm-8 mx-auto">
                                <Slide delay={50} direction="up" triggerOnce>
                                    <article className="why_trust_container">
                                        <div className="why_trust_img_area">
                                            <img src="/assets/images/website/about-page/stages_of_construction_2.jpg" loading="lazy" alt="Stages of Construction" />
                                        </div>
                                        <div className="why_trust_desc_area">
                                            <h4>Stages of Construction</h4>
                                            <ul>
                                                <li><img src={listStyleImg} loading="lazy" alt="" />Focus on Progress</li>
                                                <li><img src={listStyleImg} loading="lazy" alt="" />To Fast & Trust</li>
                                            </ul>
                                        </div>
                                    </article>
                                </Slide>
                            </div>

                            <div className="col-12 col-xl-4 col-lg-4 col-sm-8 mx-auto">
                                <Slide delay={100} direction="up" triggerOnce>
                                    <article className="why_trust_container">
                                        <div className="why_trust_img_area">
                                            <img src="/assets/images/website/about-page/final_project.jpg" loading="lazy" alt="Final Project" />
                                        </div>
                                        <div className="why_trust_desc_area">
                                            <h4>Final Project</h4>
                                            <ul>
                                                <li><img src={listStyleImg} loading="lazy" alt="" />340+ Quality Checks</li>
                                                <li><img src={listStyleImg} loading="lazy" alt="" />Customer Satisfaction</li>
                                            </ul>
                                        </div>
                                    </article>
                                </Slide>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Working process section */}
            <section className="working_process_section section__padding pt-0">
                <Fade triggerOnce>
                    <article className="working_process_container justify-content-end section__padding">
                        {/* <button className="video_play_btn p-ripple" type="button"
                            onClick={handlePlayVideo}>
                            <i className="bi bi-play-fill"></i>
                            <Ripple />
                        </button> */}
                        <div className="container-md">
                            <div className="row">
                                <div className="col-12 col-lg-6 ps-1 ps-sm-2">
                                    <div className="working_process_content">
                                        <Slide direction="up" delay={50} triggerOnce>
                                            <h3>
                                                See in details our <br />
                                                <span>Working Process</span>
                                            </h3>
                                        </Slide>
                                        <Slide direction="up" delay={100} triggerOnce>
                                            <p>
                                                Discover the steps behind our success and explore the detailed process that ensures your project is completed seamlessly.
                                            </p>
                                        </Slide>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                </Fade>
            </section>

            {/* Video player modal */}
            <Dialog headerClassName="d-none" dismissableMask
                visible={showVideoPlayerModal} className="custom_modal_dialog video_player_modal"
                onHide={() => { if (!showVideoPlayerModal) return; setShowVideoPlayerModal(false); }}
                contentClassName="video_player_content">
                <div className="custom_modal_body pb-0">
                    <button className="custom_modal_close position-absolute float p-ripple"
                        onClick={() => setShowVideoPlayerModal(false)}>
                        <i className="bi bi-x-lg"></i>
                        <Ripple />
                    </button>
                    <div className="video_container">
                        <ReactPlayer
                            url={videoUrl}
                            controls
                            muted={true}
                            width="100%"
                            height="80vh"
                            playing={showVideoPlayerModal}
                        />
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
}

export default About;